import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { ErrorLike } from '@/apis/types';
import { clearPreviewSession } from '@/common/helper';

interface UseUnauthorizeReturn {
  unauthorize: (error?: ErrorLike) => void;
}

const useUnauthorize = (): UseUnauthorizeReturn => {
  const navigate = useNavigate();

  const unauthorize = useCallback(
    (error?: ErrorLike) => {
      if (error && error?.status === 401) {
        clearPreviewSession();
        localStorage.clear();
        navigate('/login');
      }
    },
    [navigate]
  );

  return { unauthorize };
};

export default useUnauthorize;
